import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { Reveal } from '../ui-custom/Reveal';
import { theme } from '../../utils/theme';
import { useLanguage } from '../../contexts/LanguageContext';

const BACKEND_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const FAQSection = () => {
  const { language } = useLanguage();
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaq = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/faq`);
        // CORRECTION 1 : On s'assure que c'est bien une liste avant de set le state
        if (Array.isArray(response.data)) {
            setFaqData(response.data);
        } else {
            console.warn("L'API FAQ n'a pas renvoyé une liste :", response.data);
            setFaqData([]); 
        }
      } catch (error) {
        console.error('Error fetching FAQ:', error);
        // Fallback data
        setFaqData([
          { question: "Comment fonctionne le filtre intelligent ?", question_en: "How does the smart filter work?", answer: "Notre technologie utilise des micro-lamelles à cristaux liquides.", answer_en: "Our technology uses micro-slats with liquid crystals.", order: 1 },
        ]);
      } finally {
        setLoading(false);
      }
    };
    fetchFaq();
  }, []);

  // Get text based on language
  const getText = (item, field) => {
    if (language === 'en') {
      return item[`${field}_en`] || item[field];
    }
    return item[field];
  };

  const translations = {
    fr: {
      badge: "FAQ",
      title: "Questions Fréquentes",
      subtitle: "Tout ce que vous devez savoir sur le filtre intelligent SAILECtech",
      moreQuestions: "Vous avez d'autres questions ?",
      contactSupport: "Contactez notre support"
    },
    en: {
      badge: "FAQ",
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know about the SAILECtech smart filter",
      moreQuestions: "Have more questions?",
      contactSupport: "Contact our support"
    }
  };

  const t = translations[language] || translations.fr;

  return (
    <section className="py-24 relative overflow-hidden border-t" style={{ borderColor: theme.colors.border }}>
      {/* Background gradient */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-orange-500/5 rounded-full blur-[120px] pointer-events-none" />
      
      <div className="max-w-4xl mx-auto px-4 relative z-10">
        <Reveal>
          <div className="text-center mb-16">
            <div className="inline-block px-3 py-1 mb-6 rounded-full text-xs font-bold border border-white/10 bg-white/5 text-white/70">
              {t.badge}
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-500">
              {t.title}
            </h2>
            <p className="text-lg" style={{ color: theme.colors.textMuted }}>
              {t.subtitle}
            </p>
          </div>
        </Reveal>

        <Reveal delay={200}>
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : (
            <Accordion type="single" collapsible className="w-full space-y-4">
              {/* CORRECTION 2 : Ajout du '?' pour sécuriser le map */}
              {faqData?.map((faq, index) => (
                <AccordionItem 
                  key={index} 
                  value={`item-${index}`}
                  className="border border-white/10 rounded-2xl px-6 bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-colors overflow-hidden"
                  style={{ borderColor: theme.colors.border }}
                >
                  <AccordionTrigger className="text-left text-lg font-bold text-white hover:no-underline py-6 hover:text-orange-400 transition-colors">
                    {getText(faq, 'question')}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-gray-400 leading-relaxed pb-6">
                    {getText(faq, 'answer')}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </Reveal>

        <Reveal delay={400}>
          <div className="mt-12 text-center">
            <p className="text-gray-400 mb-4">
              {t.moreQuestions}
            </p>
            <button 
              className="px-6 py-3 rounded-full font-bold border transition-all hover:bg-white/5 hover:border-white/40"
              style={{ borderColor: theme.colors.border, color: theme.colors.text }}
            >
              {t.contactSupport}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};